const MuiBackdrop = {
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(113, 114, 116, 0.65)',
    },
  },
};

export default MuiBackdrop;
